export default __webpack_public_path__ + "static/media/whatsappclone.2cc75805.png";